import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './evisio2IframeWorkspaceApp.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import MDSC_SignInThirdParty from '../../MDS_Connect/ThirdParty/MDSC_SignInThirdParty';

class evisio2IframeWorkspaceApp extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private iframeContainer:HTMLDivElement;

    // Fires after MDSC sign-in completes. Lets the parent (evisio2workspaceRoot) attach
    // the evisio2 SDK to this same iframe via sdk.connect({mode:'iframeAttach', iframe}).
    // Mixed in via dojo/declare constructor args.
    public onSignInComplete: ((iframe: HTMLIFrameElement) => void) | null = null;

    private _signedInIframe: HTMLIFrameElement | null = null;

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.loadIframeSignIn();
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    private async loadIframeSignIn(){
        let signInPromt = new MDSC_SignInThirdParty();
        this.StandbyStart();
        await signInPromt.SignInUser(
            'evisio_v2',
            {
                targetInteraction: 'iFrame',
                iframeConfig: {
                    targetContainer: this.iframeContainer,
                    iframeSize: { width: '100%', height: '100%' },
                    title: 'evisio',
                    // evisio2 SDK owns the postMessage traffic inside this iframe — skip
                    // MDSC's nonce-validated listener so SDK packets don't trip its
                    // "malformed message data" warning on every handshake/ping.
                    skipIframeEvents: true,
                }
            },
            {
                // Capture the absolute-src iframe element so the SDK can attach to it
                // post-sign-in (see onOperationFinished). Fires before sign-in completes —
                // we don't connect here because the child page is still loading.
                onIframeReady: (_appName, iframe) => {
                    this._signedInIframe = iframe;
                },
                onError: () => {
                    this.StandbyStop();
                    console.log("onError");
                    //TODO - show error toast
                },
                onOperationFinished: () => {
                    this.StandbyStop();
                    console.log("onOperationFinished");
                    if (this._signedInIframe && this.onSignInComplete){
                        try { this.onSignInComplete(this._signedInIframe); }
                        catch (e){ console.warn("evisio2IframeWorkspaceApp: onSignInComplete handler threw", e); }
                    }
                },
            }
        );
    }
}

export default mdsWidget(evisio2IframeWorkspaceApp);
